const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    flexGrow: 1,
    marginRight: theme.spacing(1.5),
    whiteSpace: 'nowrap',
  },
  controlsContainer: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
    transition: 'padding-left 0.2s ease, max-width 0.2s ease',
  },
  controlsContainerShifted: {
    paddingLeft: 180,
    maxWidth: 'calc(100% - 180px)',
  },
  printStatus: {
    maxWidth: '22%',
    height: 30,
    marginRight: theme.spacing(1),
    fontFamily: ['Roboto'],
    '& .MuiChip-label': {
      fontSize: '0.78rem',
      fontWeight: 600,
      paddingLeft: 8,
      paddingRight: 8,
    },
    '& .MuiChip-icon': {
      marginLeft: 8,
      marginRight: -4,
      fontSize: '1rem',
    },
    '& .MuiChip-deleteIcon': {
      marginLeft: -2,
      marginRight: 6,
      fontSize: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '38%',
      height: 28,
      marginRight: theme.spacing(0.5),
      '& .MuiChip-label': {
        fontSize: '0.68rem',
        paddingLeft: 6,
        paddingRight: 6,
      },
    },
  },
  deviceStatusButton: {
    color: '#fff',
    padding: 6,
    marginRight: theme.spacing(0.5),
  },
  pdfContingencyToggle: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    color: '#fff',
    '& .MuiFormControlLabel-label': {
      color: '#fff',
      fontSize: '0.75rem',
      fontWeight: 600,
    },
    '& .MuiSwitch-switchBase': {
      color: '#fff',
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'rgba(255,255,255,0.4)',
    },
    '& .Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#81C784 !important',
      opacity: '1 !important',
    },
  },
  cleanMenuItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    color: '#004d40',
    fontWeight: 'bold',
  },
  customBadge: {
    backgroundColor: '#e57373',
    color: 'white',
  },
  selectLanguage: {
    color: 'white',
    fontSize: '18px',
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-icon': {
      color: 'white',
    },

  },
  languageIcon: {
    color: 'white',
    paddingRight: '6px',
  },
});

export default styles;
